import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';
import { initializeAppInsights } from './services/applicationInsights';
import { initCapacitor } from './services/capacitorInit';

const rootEl = document.getElementById('root');
const tree = (
  <ErrorBoundary>
    <App />
  </ErrorBoundary>
);

// "/" is served from build/landing.html, whose #root already holds the
// server-rendered landing page (scripts/prerenderLanding.js). Hydrating keeps
// those DOM nodes, so the hero text painted from HTML remains the LCP element
// instead of being torn down and rebuilt by a client render. Every other
// route gets the empty index.html shell and renders as before.
if (rootEl.hasChildNodes()) {
  ReactDOM.hydrate(tree, rootEl);
} else {
  ReactDOM.render(tree, rootEl);
}

// Initialize Application Insights once the page is idle. The SDK is loaded as
// a separate chunk, so neither its download nor its ~0.5 s of setup work can
// compete with the landing page's first paint or block early taps.
const startTelemetry = () => {
  if ('requestIdleCallback' in window) {
    window.requestIdleCallback(() => initializeAppInsights(), { timeout: 4000 });
  } else {
    setTimeout(initializeAppInsights, 1500);
  }
};
if (document.readyState === 'complete') {
  startTelemetry();
} else {
  window.addEventListener('load', startTelemetry, { once: true });
}

// Initialize native platform features (no-op on web)
initCapacitor();
